import { ITranslations } from '../translations.interfaces';
import { DsTreeItem } from '@bmw-ds/components';

export interface TranslationsState {
  translations: ITranslations;
  loading: boolean;
  error: unknown;
  dsTreeItems: DsTreeItem[];
  lastTranslationKey?: string;
  lastTranslationNamespace?: string;
}
export const initialState: TranslationsState = {
  translations: {},
  loading: false,
  error: null,
  dsTreeItems: [],
  lastTranslationKey: undefined,
  lastTranslationNamespace: undefined,
};
